import { UnicodeEntity } from '@mews/enums';
import { OrderItem, WithTimeUnit } from '@mews-commander/types';
import { ConvertedCurrencyValue, LocalizedUtcTimeUnit, LocalizedUtcTimeUnitFormat } from '@mews-commander/ui';
import { SimpleListItem } from '@optimus-web/core';
import { PartialMonthDayRange } from '../../ItemsTab/PartialMonthDayRange';

interface Props extends WithTimeUnit {
    night: OrderItem;
    isMultiTaxEnvironment: boolean;
}

const DefaultProductOrderItemsListItem = ({
    night: { startUtc, totalAmount, proRataStartUtc, proRataEndUtc },
    isMultiTaxEnvironment,
    timeUnit,
}: Props) => {
    const startUtcTimeUnit = startUtc ? (
        <LocalizedUtcTimeUnit format={LocalizedUtcTimeUnitFormat.Short} timeUnit={timeUnit} utcString={startUtc} />
    ) : null;
    const timeUnitDateComponent =
        proRataStartUtc && proRataEndUtc ? (
            <PartialMonthDayRange proRataStartUtc={proRataStartUtc} proRataEndUtc={proRataEndUtc} />
        ) : (
            startUtcTimeUnit
        );

    return (
        <SimpleListItem>
            {timeUnitDateComponent}
            {UnicodeEntity.Colon}
            {UnicodeEntity.NoBreakSpace}
            <ConvertedCurrencyValue amount={totalAmount} net={isMultiTaxEnvironment} />
        </SimpleListItem>
    );
};

export default DefaultProductOrderItemsListItem;
